<template>
  <div class="AllBusinessList">
    <ul class="business-listing">
      <router-link tag="li" v-for="(item, index) in business" :key="index" :to="'/business-detail/' +item.id ">
        <span class="place-pic">
          <img :src="item.images[0]" v-if="item.images[0]"/>
          <img src="../../assets/images/placeholderImg.png" v-else>
        </span>
        <div class="bunsiness-details">
          <p>
            <span>{{item.business_name}}</span>
            <span><img src="../../assets/images/ic-walk.svg"/>{{item.distance}}</span>
          </p>
          <span class="business-listing-location">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g class="b" transform="translate(-343 -175)">
                <path
                  class="c"
                  d="M5.4-5.28a.752.752,0,0,0,1.237,0c4.553-6.6,5.4-7.278,5.4-9.7A6.016,6.016,0,0,0,6.016-21,6.016,6.016,0,0,0,0-14.984C0-12.558.845-11.881,5.4-5.28Zm.618-7.2A2.507,2.507,0,0,1,3.51-14.984,2.507,2.507,0,0,1,6.016-17.49a2.507,2.507,0,0,1,2.507,2.507A2.507,2.507,0,0,1,6.016-12.477Z"
                  transform="translate(346 197)"
                />
              </g>
            </svg>
            <span>{{item.address.street}}</span>
          </span>
          <span class="review-part">
            <star-rating :read-only="true" :rating="item.rating"></star-rating>
            <!-- <span class="review-text">19 Reviews</span> -->
          </span>
        </div>
      </router-link>
    </ul>
     <div class="goToCheckin">
            <router-link tag="span" class="checkin_icon" :to="{ path: '/add-new-business'}">
              <img src="../../assets/images/baseline-add_location-24px.svg" >
            </router-link>

        </div>
    <infinite-loading @infinite="infiniteHandler">
          <template slot="no-more">{{$t('NoRecordsavailable')}}</template>
      </infinite-loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApiCaller from "../../utils/apicaller";
import types from "../../store/types";
import Vue from "vue";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import StarRating from "vue-star-rating";
Vue.use(InfiniteLoading);
Vue.use(VueCookie);
export default {
  name: "BusinessList",
  components: {
    InfiniteLoading,
    StarRating,
  },
  data() {
    return {
      limit: 0
    };
  },
  computed: {
    ...mapState(["business", "rating"])
  },
  methods: {
    infiniteHandler($state) {
      if (this.limit < 100) {
        ApiCaller(
          `/business?lat=${VueCookie.get("latitude")}&long=${VueCookie.get(
            "longitude"
          )}&limit=${this.limit}`,
          "get"
        ).then(data => {
          if (data.length) {
            this.limit += 10;
            this.$store.commit(types.LOADBUSINESS, data);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
    }
  }
};
</script>

<style></style>
